import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const BUILDER_STUDY_PAYLOAD_LAB_TEST_LANG: {
  BUILDER_STUDY_PAYLOAD_LAB_TEST_PAGE_TITLE_DESCRIPTION: MvnCodeFE;
} = {
  BUILDER_STUDY_PAYLOAD_LAB_TEST_PAGE_TITLE_DESCRIPTION: {
    ko: "실험실 항목을 조회할 수 있습니다.",
    en: "View your lab tests.",
  },
};

MvnCodeInitiate(BUILDER_STUDY_PAYLOAD_LAB_TEST_LANG);
